import { useMutation, useQueryClient } from "@tanstack/react-query";
import { acceptSolutionApi } from "../../services/solution/accept.solution.api";

export const useAcceptSolutionApi = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (id: any) => acceptSolutionApi(id?.id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["solution"],
      });
    },
  });
};
